import { Areas, Obstacle, LogicalSpace } from '@thive/fddm-types';

import { logger } from '@/modules/common/logging/logger';

import { Collision } from '../types';
import { ICollisionService } from './ICollisionService';

export class CollisionServiceLogDecorator implements ICollisionService {
  private decoree: ICollisionService;

  constructor(decoree: ICollisionService) {
    this.decoree = decoree;
  }

  initialize(source: { areas?: Areas; obstacles?: Obstacle[]; logicalSpaces?: LogicalSpace[] }): {
    newCollisions: Collision[];
    removedCollisions: Collision[];
  } {
    const start = this.logStart(`initialize`);
    const { newCollisions, removedCollisions } = this.decoree.initialize(source);
    this.logEnd(`initialize`, start);
    return { newCollisions, removedCollisions };
  }

  update(source: {
    updatedAreas?: Areas;
    updatedObstacles?: Obstacle[];
    updatedLogicalSpaces?: LogicalSpace[];
    deletedAreas?: Areas;
    deletedObstacles?: Obstacle[];
    deletedLogicalSpaces?: LogicalSpace[];
  }): { newCollisions: Collision[]; removedCollisions: Collision[] } {
    const start = this.logStart(`update`);
    const result = this.decoree.update(source);
    this.logEnd(`update`, start);
    return result;
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
